var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Controller } from "@hotwired/stimulus";
export default class controller_default extends Controller {
  connect() {
    this.state = { originalTexts: /* @__PURE__ */ new Map(), mode: null };
    this.errorEl = this.element.querySelector(
      "[data-translation-actions-error]"
    );
  }
  translate(event) {
    return __async(this, null, function* () {
      yield this._applyAction(event.currentTarget, "translate");
    });
  }
  simplify(event) {
    return __async(this, null, function* () {
      yield this._applyAction(event.currentTarget, "simplify");
    });
  }
  hideError() {
    var _a;
    (_a = this.errorEl) == null ? void 0 : _a.classList.add("hidden");
  }
  // — Private —
  _applyAction(btn, action) {
    return __async(this, null, function* () {
      this.hideError();
      if (this.state.mode === action) {
        this._restore(action);
        return;
      }
      const allEls = this._findContentEls();
      const els = allEls.filter((el) => el.textContent.trim() !== "");
      if (!els.length) return;
      for (const el of els) {
        if (!this.state.originalTexts.has(el)) {
          this.state.originalTexts.set(el, el.innerText.trim());
        }
      }
      const origLabel = btn.querySelector("span").textContent;
      const loadingLabel = action === "translate" ? this.labelTranslatingValue : this.labelSimplifyingValue;
      btn.querySelector("span").textContent = loadingLabel;
      btn.disabled = true;
      try {
        const endpoint = action === "translate" ? "/translator" : "/simplifier";
        const key = action === "translate" ? "Translated Text" : "simplified Text";
        const texts = els.map((el) => this.state.originalTexts.get(el));
        const translated = yield this._callApi(endpoint, texts, key);
        for (let i = 0; i < els.length; i++) {
          els[i].innerText = translated[i];
          this._flashSuccess(els[i]);
        }
        const other = action === "translate" ? "simplify" : "translate";
        this._setButtonMode(other, "idle");
        this._setButtonMode(action, "active");
        this.state.mode = action;
      } catch (e) {
        this._showError(this.msgServerUnreachableValue);
        btn.querySelector("span").textContent = origLabel;
      } finally {
        btn.disabled = false;
      }
    });
  }
  _restore(action) {
    if (!this.state.originalTexts.size) return;
    for (const [el, orig] of this.state.originalTexts) {
      el.innerText = orig;
    }
    this._setButtonMode(action, "idle");
    this.state.mode = null;
  }
  // Returns all content elements matching any of the configured selectors,
  // scoped to the nearest ancestor matching scopeSelectorValue (or parentElement
  // when no scope is set). Uses querySelectorAll so selectors like [data-option-body]
  // correctly match multiple sibling elements within the scope.
  _findContentEls() {
    const scope = this.scopeSelectorValue ? this.element.closest(this.scopeSelectorValue) : this.element.parentElement;
    if (!scope) return [];
    return this.contentSelectorsValue.flatMap((sel) => [
      ...scope.querySelectorAll(sel)
    ]);
  }
  _callApi(endpoint, texts, key) {
    return __async(this, null, function* () {
      const body = { text: texts, languageOutput: this.languageOutputValue };
      const response = yield fetch(this.apiUrlValue + endpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body)
      });
      if (!response.ok) throw new Error("unavailable");
      const data = yield response.json();
      return data.map((item) => item[key]);
    });
  }
  _showError(message) {
    if (!this.errorEl) return;
    this.errorEl.querySelector(
      "[data-translation-actions-error-message]"
    ).textContent = message;
    if (this.errorContainerSelectorValue) {
      const container = this.element.closest(this.errorContainerSelectorValue);
      if (container && this.errorEl.parentElement !== container) {
        container.insertAdjacentElement("afterbegin", this.errorEl);
      }
    }
    this.errorEl.classList.remove("hidden");
  }
  _setButtonMode(action, mode) {
    const selector = action === "translate" ? "[data-action*='#translate']" : "[data-action*='#simplify']";
    const btn = this.element.querySelector(selector);
    if (!btn) return;
    const label = mode === "active" ? action === "translate" ? this.labelRemoveTranslationValue : this.labelRemoveSimplificationValue : action === "translate" ? this.labelTranslateValue : this.labelSimplifyValue;
    btn.querySelector("span").textContent = label;
  }
  _flashSuccess(el) {
    el.style.transition = "background-color 0.5s";
    el.style.backgroundColor = "#f0fdf4";
    setTimeout(() => {
      el.style.backgroundColor = "transparent";
    }, 1e3);
  }
}
__publicField(controller_default, "values", {
  contentSelectors: { type: Array, default: [] },
  scopeSelector: { type: String, default: "" },
  apiUrl: String,
  languageOutput: String,
  labelTranslate: String,
  labelSimplify: String,
  labelRemoveTranslation: String,
  labelRemoveSimplification: String,
  labelTranslating: String,
  labelSimplifying: String,
  msgServerUnreachable: String,
  errorContainerSelector: { type: String, default: "" }
});
